module.exports = __webpack_public_path__ + "img/futter.acd2eeda.svg";